import TimeKeeper from '../engine/TimeKeeper';
import Attack from './Attacks';
import _cloneDeep from 'lodash/cloneDeep';

export default class GPSAttack extends Attack {
    constructor(aircraft, isHighPower, startTimestamp) {
        super(startTimestamp);
        this.lastUpdateTime = startTimestamp;
        /**
         * Copy of the aircraft when it is not moving
         *
         * Part of non-moving attack
         *
         * @for AircraftModel
         * @property nonStandingCopy
         * @type {AircraftModel}
         * @default null
         * @private
         */
        this.visibleCopy = _cloneDeep(aircraft);

        /**
         * Flag to indicate if the attack is high power
         *
         * @type {boolean}
         * @private
         * @memberof GPSAttack
         */
        this.isHighPower = isHighPower;

        /**
         * Real position of the aircraft
         * @type {Array<number>}
         * @private
         * @memberof GPSAttack
         */
        this.realAircraftPosition = aircraft.positionModel.gps;
    }

    update(aircraft) {
        this.realAircraftPosition = aircraft.positionModel.gps;
    }

    getVisibleCopy() {
        if (!this.isHighPower && TimeKeeper.accumulatedDeltaTime > this.lastUpdateTime + 1) { // Update every second
            this.lastUpdateTime = TimeKeeper.accumulatedDeltaTime
            this.randomizePosition();
        }
        return this.visibleCopy;
    }

    randomizePosition() {
        const randomizeRadius = 0.07;
        const falseLatitude = this.realAircraftPosition[0] + (Math.random() - 0.5) * randomizeRadius;
        const falseLongitude = this.realAircraftPosition[1] + (Math.random() - 0.5) * randomizeRadius;

        this.visibleCopy.positionModel.setCoordinates([falseLatitude, falseLongitude]);
    }
}
